import { CheckboxListOption } from "./CheckboxListFilter.tsx";

export function uniqueSortedOptions(
  options: CheckboxListOption<string>[],
): CheckboxListOption<string>[] {
  const labelByValue = new Map(options.map((o) => [o.value, o.label]));
  return Array.from(labelByValue, ([value, label]) => ({ value, label })).sort(
    (a, b) => a.label.localeCompare(b.label),
  );
}
